<template>
<section class="portfolio-home ">

      <router-link v-for="(projet, idx) in projets" :key="idx" :to=projet.link :style="{ backgroundImage: 'url('+require('./../../assets/'+projet.bg+'')+')'}"   class="portfolio-item">
        <div class="portfolio-item-ombre"></div>
        <img :src="require(`./../../assets/${projet.logo}`)" :alt=projet.alt :class="[light ? 'light' : '']"/>
      </router-link>


    </section>
</template>

<script>


export default {
    name: 'PortfolioGrid', 
    props : ['remove', 'portfolio', 'light'],
    data() {
      return {
        projets : []
      }
      
    },
    mounted() {     
      let item = [...this.$store.getters.getPortfolios]

      item.sort(() => Math.random() - 0.5);
      this.projets = item.filter(e => !this.remove.includes(e.number));
      this.portfolio ? this.projets = this.projets.splice(0, this.portfolio  ) : null;
    }
}
</script>

<style scoped>
.portfolio-home {
  display: flex;
  flex-direction: row;
  width:100%;
  flex-wrap: wrap;
}

.portfolio-box .portfolio-item {
  width:calc(25% - 10px);
  border:5px solid #fff;
}

.portfolio-item {
  width:25%;
  position:relative;
  display: flex;
  justify-content: center;
  align-items: center;
    background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.portfolio-item img {
  position: relative;
  z-index:999;
  max-width: 80%;;
}

.portfolio-item:hover  {
  cursor:pointer;
}

.portfolio-item:hover .portfolio-item-ombre {
  opacity:0;
}

.portfolio-item:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.portfolio-item-ombre {
  position:absolute;
  opacity: 1;
  top:0;
  bottom:0;
  right:0;
  left:0;
  background:rgba(0,0,0,0.7);
  transition:1s;
}

.light {
  max-width: 80%;
}

@media screen and (max-width: 767px) {
  .portfolio-item {
    width:50%;
  }

  .portfolio-box .portfolio-item {
    width:50%;
    border:none;
  }  

}

@media screen and (min-width: 767px) and (max-width: 1000px) {
  .portfolio-item img {
    max-width:50%;
  }
}

</style>